module.exports = __webpack_public_path__ + "img/markerIcon.397178ae.svg";